// Thin wrappers around the single-case Αστικά endpoints, with the same
// payloads CaseCard sends. `api` is an axios instance (useAxiosPrivate()).

const JSON_OPTIONS = {
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
};

export const setFav = (api, id, fav) =>
  api.post("/cases/fav", JSON.stringify({ id, fav }), JSON_OPTIONS);

export const recheck = (api, id) =>
  api.post("/cases/check", JSON.stringify({ id: String(id) }), JSON_OPTIONS);

export const deleteCase = (api, id) =>
  api.patch("/cases", JSON.stringify({ key: String(id) }), JSON_OPTIONS);

export const saveNote = (api, id, note) =>
  api.post("/cases/note", JSON.stringify({ id: String(id), note }), JSON_OPTIONS);

export const selectDiadikasia = (api, id, data) =>
  api.post(`/userinput/select_diadikasia/${id}`, JSON.stringify({ data }), JSON_OPTIONS);

// Queues every case for a check. Limited server-side to once per day.
// Resolves to a user-facing message; never throws.
export const startBulkCheckAll = async (api) => {
  try {
    const response = await api.post(
      "/cases/check/bulk",
      JSON.stringify({ scope: "all" }),
      JSON_OPTIONS
    );
    const queuedCount = response?.data?.queued_count ?? 0;
    return {
      ok: true,
      message:
        queuedCount > 0
          ? `Ξεκίνησε ο μαζικός έλεγχος. Υποθέσεις στην ουρά: ${queuedCount}.`
          : "Δεν βρέθηκαν νέες υποθέσεις για μαζικό έλεγχο.",
    };
  } catch (err) {
    const status = err?.response?.status;
    if (status === 429 && err?.response?.data?.code === "bulk_daily_limit") {
      const nextAllowed = err?.response?.data?.next_allowed_at;
      return {
        ok: false,
        message: nextAllowed
          ? `Ο μαζικός έλεγχος επιτρέπεται μία φορά την ημέρα. Επόμενη δυνατότητα: ${nextAllowed}`
          : "Ο μαζικός έλεγχος επιτρέπεται μία φορά την ημέρα.",
      };
    }
    console.error(err);
    return { ok: false, message: "Αποτυχία εκκίνησης μαζικού ελέγχου." };
  }
};
